import {Box, CircularProgress} from '@mui/material';
import Button from '@mui/material/Button';
import type * as React from 'react';

type Props = React.ComponentPropsWithoutRef<typeof Button> & {
    loading?: boolean;
};

const LoadingButton: React.FC<Props> = ({loading, ...rest}: Props) => {
    return (
        <Box
            sx={{
                display: 'inline-block',
                position: 'relative',
            }}
        >
            <Button {...rest} />
            {loading && (
                <CircularProgress
                    size={24}
                    sx={{
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        marginLeft: -12,
                        marginTop: -12,
                    }}
                />
            )}
        </Box>
    );
};

export default LoadingButton;
